/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterFooterComponent} from './filter-footer.component';

@NgModule({
    declarations: [FilterFooterComponent],
    imports: [
        CommonModule
    ],
    exports: [FilterFooterComponent]
})

export class FilterFooterModule {

}

